import React from 'react';
import Form from 'components/form';
import { H2 } from 'components/typography';
import { Row } from 'components/layout';
import { CopyIcon } from 'routes/admin/style';
import LogoutMenu from 'routes/admin/components/logout-menu';
import { useTranslation } from 'i18n';
import { useHistory } from 'react-router';
import { WithMargin } from 'components/layout';
import createSignInCode from 'graphql/admin/create-sign-in-code-mutation';
import { copyToClipboard } from 'utils/js';
import toast from 'services/toast';

function AdminSignInCodeForm() {
  const { t } = useTranslation();
  const history = useHistory();
  const [code, setCode] = React.useState('');

  function onSubmit() {
    createSignInCode({}).then((response) => {
      if (response.isSuccess) {
        setCode(response.getField('data.code'));
      }
    });
  }

  function copyLoginUrl(value) {
    return function () {
      try {
        copyToClipboard(window.location.origin + '/register?code=' + value);
        toast.success(t('Successfully copied to clipboard'));
      } catch (error) {
        toast.success(t('Something went wrong'));
      }
    };
  }

  return (
    <>
      <LogoutMenu />
      <H2>{t('Sign in code')}</H2>
      <Form initialValues={{ code }} onSubmit={onSubmit}>
        {(form) => (
          <>
            <Form.TextInput
              name="code"
              style={{ width: '20%' }}
              label={t('Code')}
              iconRight={(value) => {
                return value ? (
                  <CopyIcon onClick={copyLoginUrl(value)} />
                ) : null;
              }}
            />
            <WithMargin top="30px">
              <Row>
                <Form.SubmitButton
                  label={t('Create code')}
                  onClick={form.handleSubmit}
                />
                <WithMargin left="30px">
                  <Form.Button
                    secondary
                    label={t('Back to list')}
                    onClick={() => history.push('/admin/sign-in-code/list')}
                  />
                </WithMargin>
              </Row>
            </WithMargin>
          </>
        )}
      </Form>
    </>
  );
}

export default AdminSignInCodeForm;
